import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-information-banner',
  templateUrl: './information-banner.component.html',
  styleUrls: ['./information-banner.component.scss'],
  standalone: false,
})
export class InformationBannerComponent implements OnInit {
  @Input() id: string;
  @Input() icon: string;
  @Input() bodyText: string;
  @Input() title: string;
  @Input() actionLabel: string;
  @Input() route: string;
  @Input() routeType: string;
  @Input() display: boolean;
  @Input() queryParams: string;
  @Input() showButton = true;
  @Input() customClass: string;
  @Input() isFlex: boolean = false;
  @Input() flexDirection: string = 'row';
  @Output() sendClick = new EventEmitter<boolean>();

  constructor() {}

  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   * On click handle from route button component and emit send click output to calling
   * component
   */
  onClick(): void {
    this.sendClick.emit(true);
  }
}
